export async function importModule() {
  return await import(/* webpackChunkName: "tui-image-editor" */ 'tui-image-editor');
}